import React, { useState, useEffect } from 'react';

// Español
import es_page1 from '../images/menus/es_page1.webp';
import es_page2 from '../images/menus/es_page2.webp';
import es_page3 from '../images/menus/es_page3.webp';
// Inglés
import en_page1 from '../images/menus/en_page1.webp';
import en_page2 from '../images/menus/en_page2.webp';
import en_page3 from '../images/menus/en_page3.webp';
// Francés
import fr_page1 from '../images/menus/fr_page1.webp';
import fr_page2 from '../images/menus/fr_page2.webp';
import fr_page3 from '../images/menus/fr_page3.webp';

import es_pdf from '../pdfs/Carta_Txoko_ESP.pdf';
import en_pdf from '../pdfs/Carta_Txoko_ENG.pdf';
import fr_pdf from '../pdfs/Carta_Txoko_FR.pdf';

export default function Menu() {
    const [selectedLanguage, setSelectedLanguage] = useState('es');

    const menuImages = {
        es: [es_page1, es_page2, es_page3],
        en: [en_page1, en_page2, en_page3],
        fr: [fr_page1, fr_page2, fr_page3]
    };

    const menuPdfs = {
        es: es_pdf,
        en: en_pdf,
        fr: fr_pdf
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [selectedLanguage]);

    const menuLanguages = [
        { id: 'es', name: 'ESPAÑOL' },
        { id: 'en', name: 'ENGLISH' },
        { id: 'fr', name: 'FRANÇAIS' }
    ];

    const handleDownload = () => {
        window.open(menuPdfs[selectedLanguage], '_blank');
    };

    return (
        <div className="bg-[#e4e4e4] font-ubuntu">
            <div className="bg-gray-900 w-full py-6 z-10 relative">
                <div className="container mx-auto px-4">
                    <div className="flex flex-col items-center mb-4">
                        <h2 className="text-white text-3xl font-bold mb-6 font-barlow">SELECCIONA TU IDIOMA</h2>
                        <div className="grid grid-cols-3 gap-4 w-full max-w-3xl">
                            {menuLanguages.map((language) => (
                                <button
                                    key={language.id}
                                    onClick={() => setSelectedLanguage(language.id)}
                                    className={`py-3 px-4 text-center text-sm font-montserrat font-semibold uppercase transition-all duration-300 ${selectedLanguage === language.id
                                            ? 'bg-white text-gray-900'
                                            : 'bg-gray-700 text-white hover:bg-gray-600'
                                        }`}
                                >
                                    {language.name}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mx-auto px-4 py-6">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-gray-900 font-montserrat text-3xl font-bold uppercase">
                        {selectedLanguage === 'es' && 'Menú'}
                        {selectedLanguage === 'en' && 'Menu'}
                        {selectedLanguage === 'fr' && 'Menu'}
                    </h2>
                    <button
                        onClick={handleDownload}
                        className="px-4 py-2 bg-gray-900 text-white font-montserrat text-sm uppercase hover:bg-gray-800 transition-colors duration-300"
                    >
                        {selectedLanguage === 'es' && 'DESCARGAR PDF'}
                        {selectedLanguage === 'en' && 'DOWNLOAD PDF'}
                        {selectedLanguage === 'fr' && 'TÉLÉCHARGER PDF'}
                    </button>
                </div>
            </div>

            <div className="w-full">
                <div className="flex flex-col items-center">
                    <div className="w-full max-w-3xl mx-auto">
                        {menuImages[selectedLanguage].map((image, index) => (
                            <img
                                key={index}
                                src={image}
                                alt={`Menu ${selectedLanguage} page ${index + 1}`}
                                className="w-full h-auto block"
                                style={{ marginTop: '-1px', marginBottom: '-1px' }}
                            />
                        ))}
                    </div>
                </div>
            </div>

            <div className="h-16"></div>
        </div>
    );
}